import { apiSlice } from "../../apiSlice";
const headers = { Modulecima: "dashboax" };
export const criticidApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicCriticid: builder.query({
      query: (params) => ({
        url: `/Dashboax/Graphics/Criticid`,
        method: "GET",
        headers,
        params,
      }),
    }),
    getQuantityCritical: builder.query({
      query: () => ({
        url: `/Dashboax/Graphics/Criticid/getQuantityOperations`,
        method: "GET",
        headers,
      }),
    }),
    getGroupById: builder.mutation({
      query: (params) => ({
        url: `/Dashboax/Graphics/Criticid/getGroupById`,
        method: "GET",
        headers,
        params,
      }),
    }),
  }),
});

export const { useLazyGetDataGraphicCriticidQuery, useGetQuantityCriticalQuery, useGetGroupByIdMutation } =
  criticidApiSlice;
